import React, { useEffect, useState } from 'react';
import firebase from '../db/firebase/firebase';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
  deleteDoc,
} from 'firebase/firestore';
import { Trash2, Filter } from 'lucide-react';

const RequestsQuotation = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const q = query(collection(firebase.db, 'quotes'), orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(q, snapshot => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setRequests(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const toggleState = async (id, currentState) => {
    const newState = currentState === 'pending' ? 'answered' : 'pending';
    const docRef = doc(firebase.db, 'quotes', id);
    await updateDoc(docRef, {
      'state': newState,
    });
  };

  const deleteRequest = async (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this request? This action cannot be undone.');
    if (confirmed) {
      const docRef = doc(firebase.db, 'quotes', id);
      await deleteDoc(docRef);
    }
  };

  const filteredRequests = requests.filter(({ state }) => {
    if (filter === 'all') return true;
    return state === filter;
  });

  if (loading) {
    return (
      <div className="flex-1  h-full flex items-center justify-center bg-white z-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-gray-800"></div>
      </div>
    );
  }

  return (
    <div className="h-screen flex-1 overflow-y-auto p-6 bg-gray-100">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Requests for quotation</h1>
        <div className="flex items-center gap-2">
          <Filter className="text-gray-600" size={20} />
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="p-2 border border-gray-300 rounded-md bg-white shadow-sm"
          >
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="answered">Answered</option>
          </select>
        </div>
      </div>

      <div className="flex flex-1 flex-wrap gap-4">
        {filteredRequests.length === 0 ? (
          <p className="text-center w-full text-gray-500 text-lg">
            No requests found.
          </p>
        ) : (
          filteredRequests.map(({ id, name, email, phone, state, address, createdAt }) => (
            <div
              key={id}
              className="min-w-[300px] relative flex-1 bg-white shadow-md rounded-lg p-4 flex flex-col justify-between"
            >
              <Trash2
                size={20}
                className="text-red-500 hover:text-red-700 cursor-pointer absolute top-3 right-3"
                onClick={() => deleteRequest(id)}
              />

              <div className={state === 'answered' ? 'line-through text-gray-500' : ''}>
                <p><span className="font-semibold">Name:</span> {name}</p>
                <p><span className="font-semibold">Email:</span> {email}</p>
                <p><span className="font-semibold">Phone:</span> {phone}</p>
                <p><span className="font-semibold">Address:</span> {address}</p>
              </div>

              <div className="flex justify-between items-center mt-4">
                <p className="text-sm text-gray-400">
                  {createdAt?.toDate ? createdAt.toDate().toLocaleDateString() : '—'}
                </p>

                <label className="relative inline-block w-10 h-6 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={state === 'answered'}
                    onChange={() => toggleState(id, state)}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-6 bg-gray-300 rounded-full peer-checked:bg-red-500 transition-colors duration-300"></div>
                  <div className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-4"></div>
                </label>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RequestsQuotation;